var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingProgressBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 979 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Progress Bar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "progress-bar",
    d: "M16.4993 14.707H967",
    stroke: "#ACB1B6",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "progress-bar-colored",
    d: "M16.4995 14.7529H967.001",
    stroke: "#E2A971",
    strokeWidth: 4,
    strokeDasharray: 1920,
    strokeDashoffset: 1920
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#E2A971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stage-three",
    d: "M662 14.5C662 18.6421 658.642 22 654.5 22C650.358 22 647 18.6421 647 14.5C647 10.3579 650.358 7 654.5 7C658.642 7 662 10.3579 662 14.5Z",
    fill: "#ACB1B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stage-two",
    d: "M344 14.5C344 18.6421 340.642 22 336.5 22C332.358 22 329 18.6421 329 14.5C329 10.3579 332.358 7 336.5 7C340.642 7 344 10.3579 344 14.5Z",
    fill: "#ACB1B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 14",
    d: "M22 14.5C22 18.6421 18.6421 22 14.5 22C10.3579 22 7 18.6421 7 14.5C7 10.3579 10.3579 7 14.5 7C18.6421 7 22 10.3579 22 14.5Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "stage-four",
    cx: 971.5,
    cy: 14.5,
    r: 7.5,
    fill: "#ACB1B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingProgressBar);
export default __webpack_public_path__ + "static/media/bookingProgressBar.a7f789420fe183d246a47c23a0ce96ed.svg";
export { ForwardRef as ReactComponent };